module.exports = __webpack_public_path__ + "static/media/2022_2A3A9623.22a181e2.jpg";